import { LinkedItem, LinkedItemSon, SceneObjects } from '@types'

export default function isLinked(
  linkedItem?: SceneObjects,
): linkedItem is LinkedItem | LinkedItemSon {
  return (
    Boolean(linkedItem) && (linkedItem?.type === 'linkedItem' || linkedItem?.type === 'linkedSon')
  )
}
